import store from '@/store'
import { awaitGetter } from '@/utils/store/store-utils'
import BookmarksView from '@/views/Bookmarks/All.vue'

export default [
  {
    path: '/bookmarks',
    components: {
      default: BookmarksView,
      sidebar: () => import('@/views/Bookmarks/components/BookmarksSidebar.vue'),
      appbar: () => import('@/views/Bookmarks/components/BookmarkAppBar.vue'),
      footer: () => import('@/components/AppFooterExpandable.vue'),
    },
    beforeEnter: async (to, from, next) => {
      await awaitGetter(store, 'collectionItems/collectionId')
      next()
    },
    meta: {
      sidebarVisibility() {
        return true
      },
      appbarVisibility: true,
      requiresAuth: true,
      transition: 't-fade',
      layoutTransition: 't-expand',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/deleted',
    components: {
      default: () => import('@/views/Bookmarks/Deleted.vue'),
      appbar: () => import('@/views/Bookmarks/components/BookmarkAppBar.vue'),
      footer: () => import('@/components/AppFooterExpandable.vue'),
    },
    beforeEnter: async (to, from, next) => {
      await awaitGetter(store, 'collectionItems/collectionId')
      next()
    },
    meta: {
      appbarVisibility: true,
      requiresAuth: true,
      transition: 't-fade',
      layoutTransition: 't-expand',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/add',
    component: () => import('@/views/Bookmarks/AddBookmark.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/:bookmarkId/edit',
    component: () => import('@/views/Bookmarks/Edit.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/bulk/add-tags',
    component: () => import('@/views/Bookmarks/BulkEditTags.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/bulk/remove-tags',
    component: () => import('@/views/Bookmarks/BulkRemoveTags.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/:bookmarkId/tags',
    component: () => import('@/views/Bookmarks/EditTags.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/bulk/add-collections',
    component: () => import('@/views/Bookmarks/BulkAddToCollections.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/:id/add-collections',
    component: () => import('@/views/CollectionItems/AddToCollections.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/:bookmarkId/pin',
    component: () => import('@/views/CollectionItems/EditPinPosition.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/bookmarks/:id/notes',
    component: () => import('@/views/Bookmarks/Notes.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
]
